import { IApiError } from '@/models/apiError.model';

export const SLICE_NAME = 'auth';

export interface AuthState {
  isAuthorized: boolean;
  authToken: string | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: AuthState = {
  isAuthorized: false,
  authToken: null,
  isLoading: false,
  error: null,
};
